import { styled } from 'styled-components'

import Avatar from 'js/components/Avatar/Avatar'
import { H4 } from 'js/components/Heading'
import { USER_ACTION } from 'js/lib/constants'
import { useSiteStore } from 'js/lib/stores/SiteStore'

import { Props as UserAvatarProps } from '../UserAvatar'

import { Actions } from './Actions'
import Fields from './Fields'
import Roles from './Roles'

interface Props extends UserAvatarProps {
    viewer: {
        loggedIn: boolean
        user: {
            guid: string
        }
    }
}

const StyledProfileCard = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 300px;
    padding: 12px;
    font-size: ${(p) => p.theme.font.size.tiny};
    line-height: ${(p) => p.theme.font.lineHeight.tiny};

    .profile-card--header {
        display: flex;
        justify-content: space-between;
    }

    .profile-card--user-info {
        display: flex;
    }

    .profile-card--name {
        margin-top: 4px;
        margin-right: 20px;
        margin-left: 8px;
    }

    .profile-card--name {
        margin-left: 8px;
    }

    .profile-card--vcard-fields {
        margin-top: 8px;
    }

    .profile-card--roles {
        margin-top: 12px;
    }
`

export const ProfileCard = ({ viewer, user, isOwner }: Props) => {
    const { site } = useSiteStore()

    const { name, icon, vcard, roles } = user

    const integratedVideocallEnabled = false

    const actions: string[] = [
        ...(site?.chatEnabled &&
        viewer?.loggedIn &&
        viewer?.user?.guid !== user.guid
            ? [USER_ACTION.Chat]
            : []),
        ...(integratedVideocallEnabled ? [USER_ACTION.VideoCall] : []),
    ]

    const hasFields = vcard?.length > 0
    const hasRoles = roles?.length > 0
    const hasActions = actions?.length > 0

    return (
        <StyledProfileCard data-testid="user-avatar-popover-content">
            <div className="profile-card--header">
                <div className="profile-card--user-info">
                    <Avatar disabled name={name} image={icon} size="normal" />
                    <H4 className="profile-card--name">{name}</H4>
                </div>
                {hasActions && <Actions actions={actions} user={user} />}
            </div>
            {hasFields && (
                <Fields className="profile-card--vcard-fields" fields={vcard} />
            )}
            {hasRoles && (
                <Roles
                    className="profile-card--roles"
                    roles={roles}
                    isOwner={isOwner}
                />
            )}
        </StyledProfileCard>
    )
}

export default ProfileCard
